import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Heart } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { ActionGroup, CountSpan } from '../SocialActions.styles';
import { formatNumber, getButtonSize } from '../utils';
export var LikeButton = function(param) {
    var liked = param.liked, likesCount = param.likesCount, onLike = param.onLike, size = param.size, showCounts = param.showCounts, labels = param.labels;
    return /*#__PURE__*/ React.createElement(ActionGroup, null, /*#__PURE__*/ React.createElement(Button, {
        iconOnly: true,
        size: getButtonSize(size),
        variant: "ghost",
        icon: /*#__PURE__*/ React.createElement(Heart, {
            className: liked ? "fill-current" : "",
            strokeWidth: liked ? 2.5 : 2,
            fill: liked ? "currentColor" : "none"
        }),
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
            onLike(e);
        },
        label: labels.like || '좋아요',
        className: "border-0 ".concat(liked ? "text-red-500 dark:text-red-400" : "text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400"),
        animation: "none"
    }), showCounts && likesCount > 0 && /*#__PURE__*/ React.createElement(CountSpan, {
        $active: liked
    }, formatNumber(likesCount)));
};
